<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-table-header">
          <PageHeader :page-title="'Contractor bank details'">
            <template v-slot:buttons>
              <b-button
                class="button title-container__controls-item"
                :variant="isShowFilter ? 'secondary' : 'info'"
                @click="toggleShowFilter"
              >
                <span class="material-icons icon-image-preview">
                  tune
                </span>
                Filters
              </b-button>
              <b-button
                v-if="$can(permissions.CreateFinancesClientBankDetails)"
                class="button"
                variant="success"
                @click.prevent="showCreateModal"
                :disabled="isDataPageLoading"
              >
                Create
              </b-button>
            </template>
          </PageHeader>

          <Filters
            v-show="isShowFilter"
            textButtonSubmit="Filter"
            :data="getFilters"
            :isLoading="isDataPageLoading"
            @submit="setFilterBankDetails"
          />

          <TableForPage
            ref="table"
            :tableData="getBankDetailsTableData"
            :fields="getTableFields"
            v-if="getBankDetailsTableData.length"
            :perPage="getBankDetails.per_page"
            :currentPage="getBankDetails.current_page"
            :totalRows="getBankDetails.total"
            :tableRowModalFields="tableRowModal.fields"
            :isEdit="$can(permissions.UpdateAllFinancesContractorBankDetails)"
            :isRemove="$can(permissions.DeleteFinancesContractorBankDetails)"
            isShowView
            isServerRender
            noLocalSorting
            @edit="showEditModal"
            @remove="removeBankDetails"
            @update="updateBankDetails"
          />
        </div>
      </div>
    </div>

    <b-modal
      size="lg"
      hide-footer
      v-model="createModal.show"
      class="modal"
      @show="resetCreateModalForm"
    >
      <template v-slot:modal-header="{ cancel }">
        <h5 class="modal-title">{{createModal.title}}</h5>
        <button
          type="button"
          aria-label="Close"
          class="close"
          @click.prevent="cancel"
        >
          <span class="material-icons">
            close
          </span>
        </button>
      </template>
      <FormGenerator
        :data="createModal.form"
        :isLoading="isDataPageLoading"
        @submit="createBankDetails"
        :showReset="false"
        :textButtonSubmit="createModal.submitButtonText"
      >
        <template v-slot:companyName="slotProps">
          <b-form-group v-if="isBusinessEntityCompany(slotProps.fields.business_entity_type)">
            <label>{{slotProps.data.label}}</label>
            <b-form-input
              v-model="slotProps.data.value"
              :required="slotProps.data.required"
              :placeholder="slotProps.data.placeholder"
            />
          </b-form-group>
        </template>
        <template v-slot:companyNameNational="slotProps">
          <b-form-group v-if="isBusinessEntityCompany(slotProps.fields.business_entity_type)">
            <label>{{slotProps.data.label}}</label>
            <b-form-input
              v-model="slotProps.data.value"
              :required="slotProps.data.required"
              :placeholder="slotProps.data.placeholder"
            />
          </b-form-group>
        </template>
      </FormGenerator>
    </b-modal>
    <b-modal
      size="lg"
      hide-footer
      v-model="editModal.show"
      class="modal"
    >
      <template v-slot:modal-header="{ cancel }">
        <h5 class="modal-title">{{editModal.title}}</h5>
        <button
          type="button"
          aria-label="Close"
          class="close"
          @click.prevent="cancel"
        >
          <span class="material-icons">
            close
          </span>
        </button>
      </template>
      <FormGenerator
        :data="editModal.form"
        @submit="editBankDetails"
        :showReset="false"
        :textButtonSubmit="editModal.submitButtonText"
      >
        <template v-slot:companyName="slotProps">
          <b-form-group v-if="isBusinessEntityCompany(slotProps.fields.business_entity_type)">
            <label>{{slotProps.data.label}}</label>
            <b-form-input
              v-model="slotProps.data.value"
              :required="slotProps.data.required"
              :placeholder="slotProps.data.placeholder"
            />
          </b-form-group>
        </template>
        <template v-slot:companyNameNational="slotProps">
          <b-form-group v-if="isBusinessEntityCompany(slotProps.fields.business_entity_type)">
            <label>{{slotProps.data.label}}</label>
            <b-form-input
              v-model="slotProps.data.value"
              :required="slotProps.data.required"
              :placeholder="slotProps.data.placeholder"
            />
          </b-form-group>
        </template>
      </FormGenerator>
    </b-modal>
  </div>
</template>

<script>
import PageHeader from '@components/PageHeader'
import Filters from '@components/Filter/Filter'
import FormGenerator from '@components/FormGenerator'
import TableForPage from '@tables/TableForPage'
import BankDetailsMixin from '../mixins/BankDetailsMixin'
import { mapGetters } from 'vuex'

export default {
  name: 'FinanceBankDetailsContractors',
  components: {
    PageHeader,
    Filters,
    TableForPage,
    FormGenerator
  },
  mixins: [BankDetailsMixin],
  data () {
    return {
      modalTitle: 'Contractors Bank Details',
      ownershipId: 4,
      currentFields: [
        'name',
        'contractor.name',
        'currency.name',
        'country.name',
        'business_entity_type.type',
        'first_name',
        'last_name',
        'company_name',
        'actions'
      ]
    }
  },
  computed: {
    ...mapGetters({
      getAllUsers: 'getAllUsers'
    }),
    getContractors () {
      return this._getPartnerRelatedUsers(null) || []
    },
    getFilters () {
      const currentFilters = (({
        contractorId,
        currencyId,
        country,
        businessEntityTypeId,
        firstName,
        lastName,
        companyName
      }) => ({
        contractorId,
        currencyId,
        country,
        businessEntityTypeId,
        firstName,
        lastName,
        companyName
      }))(this.filters)

      return currentFilters
    },
    formMock () {
      return {
        'id': {
          name: 'id'
        },
        'contractor': {
          type: 'select',
          name: 'contractor_id',
          label: 'Contractors*',
          selectLabel: 'name',
          valueField: 'id',
          options: [],
          value: null,
          validation: [
            { name: 'required' }
          ],
          class: 'col-12'
        },
        ...this.mainFormMock
      }
    }
  },
  methods: {
    fetchAllData () {
      this.fetchBankDetails()
      Promise.all([
        this.fetchAllContractors(),
        this.fetchBusinessEntityTypes(),
        this.fetchCountries(),
        this.fetchCurrencies()
      ])
        .then(values => {
          this.setAllOptionsFilter()
        })
    },
    setAllOptionsFilter () {
      this.createModal.form.contractor.options = this.getContractors
      this.createModal.form.business_entity_type.options = this.getBusinessEntityTypes
      this.createModal.form.country.options = this.getCountries
      this.createModal.form.currency.options = this.getCurrencies

      this.editModal.form.contractor.options = this.getContractors
      this.editModal.form.business_entity_type.options = this.getBusinessEntityTypes
      this.editModal.form.country.options = this.getCountries
      this.editModal.form.currency.options = this.getCurrencies

      this.filters.contractorId.options = this.getContractors
      this.filters.businessEntityTypeId.options = this.getBusinessEntityTypes
      this.filters.currencyId.options = this.getCurrencies
      this.filters.country.options = this.getCountries

      this.isDataPageLoading = false
    }
  }
}
</script>

<style>

</style>
